import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Typography from '@material-ui/core/Typography'
import { Scrollbars } from 'react-custom-scrollbars'
import styles from './bins.module.scss'

export const useStyles = makeStyles(theme => ({
  scrollBar: {
    backgroundColor: theme.palette.secondary.main,
  },
}))

const BaseBin = ({ title, actions, children, errors }) => {
  const classes = useStyles()
  return (
    <>
      <div className={styles.binRoot}>
        <Typography variant="h3" className={styles.title}>
          {title}
        </Typography>
        {actions.map((e, i) => {
          return <span key={i}>{e}</span>
        })}
      </div>
      <div>{errors}</div>
      <div className={classes.binWrapper}>
        <Scrollbars
          style={{ height: '80vh' }}
          autoHide
          autoHideTimeout={2000}
          renderThumbVertical={({ style, ...props }) => (
            <div
              {...props}
              style={{
                ...style,
                width: '4px',
                opacity: '0.5',
              }}
              className={classes.scrollBar}
            />
          )}
        >
          {children}
        </Scrollbars>
      </div>
    </>
  )
}

export default BaseBin
